var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.708 1.84857V19.5286C15.708 21.1266 13.804 21.9766 12.614 20.8886L6.698 15.5166H1.836C0.816 15.5166 0 14.7006 0 13.6806V7.69657C0 6.67657 0.816 5.86057 1.836 5.86057H6.698L12.614 0.488566C13.804 -0.599434 15.708 0.250566 15.708 1.84857ZM23.97 2.18857C28.56 7.11857 28.56 14.2926 23.97 19.2226C23.154 20.0726 24.446 21.3986 25.262 20.5146C30.566 14.8366 30.566 6.54057 25.262 0.862566C24.446 0.0125663 23.154 1.30457 23.97 2.18857ZM21.08 4.56857C24.378 8.10457 24.378 13.2386 21.08 16.7746C20.264 17.6586 21.59 18.9506 22.372 18.0666C26.35 13.7826 26.35 7.52657 22.372 3.24257C21.59 2.39257 20.298 3.71857 21.08 4.56857ZM18.224 6.98257C20.23 9.15857 20.23 12.2186 18.224 14.3606C17.408 15.2446 18.734 16.5366 19.516 15.6526C22.202 12.7286 22.202 8.58057 19.516 5.65657C18.734 4.80657 17.408 6.13257 18.224 6.98257Z",
    fill: "#603004"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/volumeIcon.e789e6d191413e6e7e9fe6426b8f4650.svg";
export { ForwardRef as ReactComponent };